import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentId: String,
    auto: { type: Boolean, default: false },
    skipComplete: { type: Boolean, default: false },
  }

  connect() {
    if (!this.autoValue || !this.hasCurrentIdValue) return

    requestAnimationFrame(() => this.performAdvance())
  }

  advance() {
    if (!this.hasCurrentIdValue) return

    requestAnimationFrame(() => this.performAdvance())
  }

  performAdvance() {
    const currentRow = document.getElementById(this.currentIdValue)

    if (!currentRow) {
      this.cleanup()
      return
    }

    const visibleRows = this.visibleSelectionRows()
    const currentIndex = visibleRows.findIndex((row) => row.id === currentRow.id)
    const visibleNextRow = visibleRows.slice(currentIndex + 1).find((row) => this.needsSelection(row))

    if (visibleNextRow) {
      this.openRow(visibleNextRow)
      this.cleanup()
      return
    }

    const currentRoom = currentRow.closest("[data-room-row='true']")
    const rooms = Array.from(document.querySelectorAll("[data-room-row='true']"))
    const currentRoomIndex = rooms.findIndex((room) => room === currentRoom)

    for (const room of rooms.slice(currentRoomIndex + 1)) {
      const nextPart = Array.from(room.querySelectorAll("[data-selection-row='true'][data-selection-kind='part']"))
        .find((row) => this.needsSelection(row))

      if (!nextPart) {
        continue
      }

      this.openRoomAndRow(room, nextPart)
      return
    }

    this.cleanup()
  }

  visibleSelectionRows() {
    return Array.from(document.querySelectorAll("[data-selection-row='true']")).filter((row) => this.isVisible(row))
  }

  isVisible(element) {
    return element.offsetParent !== null
  }

  needsSelection(row) {
    const statusElement = row.querySelector("[data-selection-status='true']")
    const status = statusElement?.textContent?.trim()?.toUpperCase()

    if (!status || status === "EXCLUDED") return false
    if (!this.skipCompleteValue) return true

    return status === "NO SELECTION" || status === "IN PROGRESS"
  }

  openRoomAndRow(room, row) {
    const roomOptions = document.getElementById(`${room.id}_options`)

    if (roomOptions?.classList.contains("hidden")) {
      room.querySelector("[data-room-toggle='true']")?.click()
      requestAnimationFrame(() => {
        this.openRow(row)
        this.cleanup()
      })
      return
    }

    this.openRow(row)
    this.cleanup()
  }

  openRow(row) {
    row.scrollIntoView({ behavior: "smooth", block: "center" })
    row.querySelector("[data-selection-link='true']")?.click()
  }

  cleanup() {
    if (!this.autoValue) return

    this.element.remove()
  }
}
